import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--down",
  "use": "icon-arrow--down-usage",
  "viewBox": "0 0 15 8",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 8\" id=\"icon-arrow--down\"><path d=\"M8.417 6.142a1.093 1.093 0 0 1 0 1.54 1.074 1.074 0 0 1-1.529 0L1.122 1.876C.102.851 1.632-.688 2.65.338l5.766 5.804H6.888L12.654.338a1.076 1.076 0 0 1 1.53 0 1.093 1.093 0 0 1 0 1.54L8.416 7.68a1.074 1.074 0 0 1-1.529 0L1.122 1.877 2.65.338l5.766 5.804Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol